import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import React from "react";

export function Form_Radio_Group(props) {
    const {item, localFormState, setLocalFormState} = props;
    const { inputSize = "normal" } = item;
    return (<>
        <FormControl component="fieldset">
            <FormLabel component="legend">{item.label}</FormLabel>
            <RadioGroup row
                        value={(localFormState[item.key] === null || localFormState[item.key] === undefined) ? '' : localFormState[item.key]}
                        onChange={
                            (e) => {
                                // submit new state to the upper system
                                setLocalFormState({
                                    ...localFormState,
                                    [item.key]: e.target.value
                                });
                            }
                        }
            >
                {item.options !== undefined && item.options.map((i) => {
                    return (
                        <FormControlLabel value={i.value} label={i.label}
                                          control={<Radio/>}/>
                    );
                })}
            </RadioGroup>
        </FormControl>
    </>);
}